module.exports = __webpack_public_path__ + "232e3b7553621119166de911ef1bd36c.png";